import { useQuery } from "@tanstack/react-query";
import { getEmailTrackingDashboard } from "../services/emailTrackingApi";
import {
  EmailTrackingQueryParams,
  EmailTrackingDashboardData,
} from "../types/email-tracking.types";

const EMAIL_TRACKING_QUERY_KEY = "emailTrackingDashboard";

interface UseEmailTrackingDashboardOptions {
  from?: string;
  to?: string;
  enabled?: boolean;
}

export const useEmailTrackingDashboard = (
  options: UseEmailTrackingDashboardOptions = {}
) => {
  const { from, to, enabled = true } = options;

  const queryParams: EmailTrackingQueryParams = {};
  if (from) queryParams.from = from;
  if (to) queryParams.to = to;

  return useQuery<EmailTrackingDashboardData, Error>({
    queryKey: [EMAIL_TRACKING_QUERY_KEY, from, to],
    queryFn: async () => {
      const response = await getEmailTrackingDashboard(queryParams);
      return response.data;
    },
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000),
  });
};

export default useEmailTrackingDashboard;
